// Skerpa Agent configuration store
// Persists Hermes gateway/API settings to localStorage

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { SkerpaMode } from '@ispot/shared'

export type SkerpaLayout = 'floating' | 'sidebar'

interface SkerpaState {
  // Connection
  gatewayUrl: string
  apiUrl: string
  enabled: boolean

  // Agent mode
  skerpaMode: SkerpaMode

  // Layout preference
  skerpaLayout: SkerpaLayout

  // Status (not persisted)
  gatewayAvailable: boolean
  apiAvailable: boolean

  // Actions
  setGatewayUrl: (url: string) => void
  setApiUrl: (url: string) => void
  setEnabled: (enabled: boolean) => void
  setSkerpaMode: (mode: SkerpaMode) => void
  setSkerpaLayout: (layout: SkerpaLayout) => void
  setStatus: (gateway: boolean, api: boolean) => void
}

export const useSkerpaStore = create<SkerpaState>()(
  persist(
    (set) => ({
      gatewayUrl: 'http://localhost:8644',
      apiUrl: 'http://localhost:8642',
      enabled: true,
      skerpaMode: 'standard',
      skerpaLayout: 'floating',
      gatewayAvailable: false,
      apiAvailable: false,

      setGatewayUrl: (url) => set({ gatewayUrl: url }),
      setApiUrl: (url) => set({ apiUrl: url }),
      setEnabled: (enabled) => set({ enabled }),
      setSkerpaMode: (mode) => set({ skerpaMode: mode }),
      setSkerpaLayout: (layout) => set({ skerpaLayout: layout }),
      setStatus: (gateway, api) => set({ gatewayAvailable: gateway, apiAvailable: api }),
    }),
    {
      name: 'ispot-skerpa-config',
      partialize: (state) => ({
        gatewayUrl: state.gatewayUrl,
        apiUrl: state.apiUrl,
        enabled: state.enabled,
        skerpaMode: state.skerpaMode,
        skerpaLayout: state.skerpaLayout,
      }),
    },
  ),
)
